import CloseOutline16 from '@carbon/icons-react/es/close--outline/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { FileAttachment } from 'api/attachments';
import { User } from 'api/models';
import { Button } from 'components/atoms/button';
import { FileThumbnail } from 'components/atoms/file-thumbnail';
import { IconWrapper } from 'components/atoms/icon-shell/icon-shell';
import { AuthorTime } from 'components/organisms/conversations/messages-list/user-message/author-time';
import { fullName } from 'utils/full-name';
import styles from './user-message-reply.module.css';

export const UserMessageReply: FC<{
  attachments?: FileAttachment[];
  className?: string;
  content: string;
  isPrivate?: boolean;
  replyAuthor?: User;
  showReplyTo?: boolean;
  onClear?(): void;
}> = ({
  attachments,
  className = '',
  content,
  isPrivate,
  replyAuthor,
  showReplyTo = true,
  onClear,
}) => (
  <>
    {showReplyTo && (
      <span className={styles.reply__hint}>
        <FormattedMessage id="conversations.replied_to" />
      </span>
    )}
    <div
      className={`${styles.wrapper} ${isPrivate ? 'private' : ''} ${className}`}
    >
      <div className={styles.content}>
        <div className={styles.reply__author}>
          <span>{replyAuthor != null ? fullName(replyAuthor) : 'You'}</span>
          {replyAuthor != null && <AuthorTime user={replyAuthor} />}
        </div>
        {content ? (
          <div
            className={styles.rte}
            // eslint-disable-next-line react/no-danger, @typescript-eslint/naming-convention
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          <span className="caption">
            <FormattedMessage id="attachments.label" />
          </span>
        )}
      </div>
      {attachments && (
        <FileThumbnail
          className={styles.attachment}
          fileName={attachments[0]?.name}
          id={attachments[0].attachmentId}
          url={attachments[0]?.location}
          isBasicPreview
        />
      )}
      {onClear && (
        <Button
          type="text"
          icon={
            <IconWrapper>
              <CloseOutline16 />
            </IconWrapper>
          }
          onClick={onClear}
        />
      )}
    </div>
  </>
);
